//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

//#region DevExtreme Imports

import DevExpress from 'devextreme'

//#endregion

import { Api, LocalDictionaryFactory } from './../../api/api.module'
import { LoggerService } from '../../common/common.module'
import { i18n } from '../../common/i18n/common.i18n'
import { EventsNames } from '../../../helpers/events-names'
import { CommonHelper, DataType, ActionStatus } from '../../../helpers/common-helper'
import { ColumnModel, GridRequestModel } from '../../api/api.models'
import { OpActionResult } from '../../../models/custom/op-action-result'
import { OpAction } from '../../../models/core'
import { Enums } from '../../../models/common/enums'
import { UserSessionService } from '../../../services/user-session'
import { IMRBaseControlDirectiveController } from '../base'

export interface ActionStatusOptions {
    selectedRowsNames: string[]
    actionResult: OpActionResult[]
    moduleDataType: Enums.DataType
    onActionPopupClosed?(e: any): void
}

interface ActionStatusScope extends ng.IScope {
    popupId: number

    closeButtonOptions: DevExpress.ui.dxButtonOptions

    scrollViewOptions: DevExpress.ui.dxScrollViewOptions
    statusPopupOptions: DevExpress.ui.dxPopupOptions

    allCheckBoxOptions: DevExpress.ui.dxCheckBoxOptions
    successCheckBoxOptions: DevExpress.ui.dxCheckBoxOptions
    failCheckBoxOptions: DevExpress.ui.dxCheckBoxOptions
    inProgressCheckBoxOptions: DevExpress.ui.dxCheckBoxOptions

    tileViewOptions: DevExpress.ui.dxTileViewOptions

    isLargeScreen: boolean
    showTileView: boolean

    checkBoxSucceededOn: boolean
    checkBoxFailedOn: boolean
    checkBoxInProgressOn: boolean
    checkBoxAllOn: boolean

    secondsCounter: number

    checkStatus: boolean
    isStatusPopupVisible: boolean

    succededCount: number
    inProgressCount: number
    failedCount: number

    actionStatusEqualsRunning: boolean
}

export class ActionStatusController extends IMRBaseControlDirectiveController {
    private static WAIT_SECOND = 5

    private statusPopup: DevExpress.ui.dxPopup
    private tileView: DevExpress.ui.dxTileView
    private prevousActions: string

    private visibleItems: any[]

    private breakCode: boolean = false

    private showSucceded: boolean = true
    private showFailed: boolean = true
    private showInProgress: boolean = true
    private skipDisableAll: boolean = false
    private tileActions: any[]

    private smallScreenStatusPopupHeight: number = 500
    private smallScreenStatusPopupWidth: number = 300
    private smallScreenBaseItemHeight: number = 220
    private smallScreenBaseItemWidth: number = 250
    private largeScreenStatusPopupHeight: number = 600
    private largeScreenStatusPopupWidth: number = 800
    private largeScreenBaseItemHeight: number = 150
    private largeScreenBaseItemWidth: number = 700

    private selectedRowsNames: any[]

    private moduleDataType: number

    private countDownTimeout: ng.IPromise<void>
    private tileViewReadyPromise: ng.IPromise<void>
    private actionStatusOptions: ActionStatusOptions

    constructor(private $scope: ActionStatusScope, $q: ng.IQService, $element: JQuery, $timeout: ng.ITimeoutService, private api: Api, logger: LoggerService, private localDictionary: LocalDictionaryFactory, protected userSession: UserSessionService) {
        super()
        
        const deferred: ng.IDeferred<any> = $q.defer()
        this.tileViewReadyPromise = deferred.promise

        $scope.secondsCounter = ActionStatusController.WAIT_SECOND

        $scope.isLargeScreen = true

        $scope.scrollViewOptions = {
            direction: 'vertical'
        }

        $scope.statusPopupOptions = {
            bindingOptions: {
                visible: "isStatusPopupVisible"
            },
            onInitialized: e => {
                this.statusPopup = e.component
            },
            onShown: () => {
                var screenWidth = angular.element("body").width()
                if (screenWidth <= 767) {
                    $scope.isLargeScreen = false
                } else {
                    $scope.isLargeScreen = true
                }
                setPopupSize()
            },
            onShowing: () => {
                $scope.checkBoxSucceededOn = true
                $scope.checkBoxFailedOn = true
                $scope.checkBoxInProgressOn = true
                $scope.checkBoxAllOn = true
                $scope.showTileView = false
                this.skipDisableAll = false
            },
            width: 800,
            height: 600,
            title: i18n("Popup", "ActionStatus"),
            onHidden: () => {
                this.breakCode = true
                $timeout.cancel(this.countDownTimeout)
                resetTile()
                if (this.actionStatusOptions.onActionPopupClosed != null) {
                    this.actionStatusOptions.onActionPopupClosed(this.tileActions)
                }
            },
            showCloseButton: true
        }

        $scope.allCheckBoxOptions = {
            onValueChanged: e => {
                if (e.value) {
                    this.showFailed = true
                    this.showInProgress = true
                    this.showSucceded = true
                    $scope.checkBoxSucceededOn = true
                    $scope.checkBoxFailedOn = true
                    $scope.checkBoxInProgressOn = true
                }
                else {
                    if (!this.skipDisableAll) {
                        this.showFailed = false
                        this.showInProgress = false
                        this.showSucceded = false
                        $scope.checkBoxSucceededOn = false
                        $scope.checkBoxFailedOn = false
                        $scope.checkBoxInProgressOn = false
                    }
                }

                this.skipDisableAll = false

                createNewActionsList()
            },
            value: true,
            bindingOptions: {
                value: 'checkBoxAllOn'
            }
        }

        $scope.successCheckBoxOptions = {
            onValueChanged: e => {
                if (e.value) {
                    this.showSucceded = true
                }
                else {
                    this.showSucceded = false
                }

                this.toggleAllOnCheckBox()
                createNewActionsList()
            },
            value: true,
            bindingOptions: {
                value: 'checkBoxSucceededOn'
            }
        }

        $scope.failCheckBoxOptions = {
            onValueChanged: e => {
                if (e.value) {
                    this.showFailed = true
                }
                else {
                    this.showFailed = false
                }

                this.toggleAllOnCheckBox()
                createNewActionsList()
            },
            value: true,
            bindingOptions: {
                value: 'checkBoxFailedOn'
            }
        }

        $scope.inProgressCheckBoxOptions = {
            onValueChanged: e => {
                if (e.value) {
                    this.showInProgress = true
                }
                else {
                    this.showInProgress = false
                }

                this.toggleAllOnCheckBox()
                createNewActionsList()
            },
            value: true,
            bindingOptions: {
                value: 'checkBoxInProgressOn'
            }
        }

        var resetTile = () => {
            $scope.tileViewOptions = null
            $timeout(() => {
                $scope.tileViewOptions = {
                    baseItemHeight: 100,
                    baseItemWidth: 700,
                    itemTemplate: 'TileTemplate',
                    activeStateEnabled: false,
                    hoverStateEnabled: false,
                    focusStateEnabled: false,
                    onInitialized: (e) => {
                        this.tileView = e.component

                        deferred.resolve(this.tileView)
                    },
                    noDataText: ""
                }
            })
        }
        resetTile()

        $scope.closeButtonOptions = {
            text: i18n("Popup", "Close"),
            onClick: () => {
                $scope.isStatusPopupVisible = false
            }
        }

        var setPopupSize = () => {
            if (!$scope.isLargeScreen) {
                if (this.statusPopup) {
                    this.statusPopup.option("width", this.smallScreenStatusPopupWidth)
                    this.statusPopup.option("height", this.smallScreenStatusPopupHeight)
                    this.statusPopup.repaint()
                }
                if (this.tileView) {
                    this.tileView.option("baseItemHeight", this.smallScreenBaseItemHeight)
                    this.tileView.option("baseItemWidth", this.smallScreenBaseItemWidth)
                    calculateHeight()
                    this.tileView.repaint()
                }
            }
            else {
                if (this.statusPopup) {
                    this.statusPopup.option("width", this.largeScreenStatusPopupWidth)
                    this.statusPopup.option("height", this.largeScreenStatusPopupHeight)
                    this.statusPopup.repaint()
                }
                if (this.tileView) {
                    this.tileView.option("baseItemHeight", this.largeScreenBaseItemHeight)
                    this.tileView.option("baseItemWidth", this.largeScreenBaseItemWidth)
                    calculateHeight()
                    this.tileView.repaint()
                }
            }
        }

        var calculateHeight = () => {
            if (this.visibleItems) {
                if ($scope.isLargeScreen) {
                    var tileViewHeight = this.visibleItems.length * this.largeScreenBaseItemHeight + (this.visibleItems.length - 1) * 20 + 50
                }
                else {
                    var tileViewHeight = this.visibleItems.length * this.smallScreenBaseItemHeight + (this.visibleItems.length - 1) * 20 + 50
                }
                if (this.tileView) {
                    this.tileView.option("height", tileViewHeight)
                }
            }
        }

        var createNewActionsList = () => {
            this.visibleItems = []
            if (this.tileActions) {
                this.tileActions.forEach(item => {
                    if (item.succeded) {
                        if (this.showSucceded) {
                            this.visibleItems.push(item)
                        }
                    }
                    else if (item.failed) {
                        if (this.showFailed) {
                            this.visibleItems.push(item)
                        }
                    }
                    else {
                        if (this.showInProgress) {
                            this.visibleItems.push(item)
                        }
                    }
                    if (this.tileView != null) {
                        this.tileView.option("items", this.visibleItems)
                        this.tileView.repaint()
                    }
                })
            }
            calculateHeight()
        }


        var countDown = (result) => {
            this.countDownTimeout = $timeout(() => {
                $scope.secondsCounter = $scope.secondsCounter - 1
                if ($scope.secondsCounter <= 0) {
                    if ($scope.checkStatus) {
                        executeGetActions(result)
                    }
                }
                else {
                    countDown(result)
                }
            }, 1000)
        }

        var getColumnNames = (columns) => {
            // WTF? Odkrycie dnia 15.06.2018 przez Adama...
            var names: any = {}
            columns.forEach(column => {
                if (column.id == CommonHelper.actionTypeColumnId) {
                    names.typeColumnName = column.name
                }
                else if (column.id == CommonHelper.actionStatusColumnId) {
                    names.statusColName = column.name
                }
                // To chyba tak miało być:
                else if (column.id == DataType.HELPER_ACTION_TARGET) {
                    names.parentElementName = column.name
                }
            })
            return names
        }

        var executeGetActions = (result: any[], isFirstTime: boolean = false) => {
            if (this.breakCode) {
                return
            }
            let checkStatus = false

            this.localDictionary.getActionColumns().then(columns => {
                var request = new GridRequestModel();
                request.pageNumber = 1
                request.pageSize = 10
                request.columns = columns

                var ids = []
                result.forEach(action => {
                    ids.push(action.idAction)
                })

                if (ids.length > 0) {
                    var primaryColumn = this.localDictionary.getPrimaryKeyColumn(CommonHelper.IdAction)
                    if (primaryColumn) {
                        var where = '[' + primaryColumn.name + '] in (' + ids.join(',') + ')'

                        var fColumn = new ColumnModel()
                        fColumn.name = primaryColumn.name
                        fColumn.id = primaryColumn.idDataType
                        fColumn.where = [where]

                        request.where = where
                    }
                }

                if (isFirstTime) {
                    $scope.isStatusPopupVisible = true
                }

                $.when<any>(
                    this.userSession
                        .getDataProvider()
                        .Action.checkActionStatus(ids),
                    this.tileViewReadyPromise
                )
                    .then((actions: OpAction[]) => {
                        $scope.showTileView = false
                        localDictionary.getActionColumns(this.moduleDataType)
                            .then((columns: ColumnModel[]) => {
                                let names: any = getColumnNames(columns)
                                this.tileActions = []
                                $scope.succededCount = 0
                                $scope.failedCount = 0
                                $scope.inProgressCount = 0
                                if (actions != null && actions.length > 0) {
                                    actions.forEach((action: OpAction, index: number) => {
                                        let failed: boolean = false
                                        let succeded: boolean = false
                                        $scope.actionStatusEqualsRunning = action.idActionStatus == ActionStatus.Running;
                                        if (action.idActionStatus === ActionStatus.Aborted || action.idActionStatus == ActionStatus.Stopped || action.idActionStatus == ActionStatus.Error) {
                                            failed = true
                                            $scope.failedCount = $scope.failedCount + 1
                                        } else if (action.idActionStatus == ActionStatus.Succeeded) {
                                            succeded = true
                                            $scope.succededCount = $scope.succededCount + 1
                                        } else {
                                            checkStatus = true
                                            $scope.inProgressCount = $scope.inProgressCount + 1
                                        }

                                        let parentElementName: string = 'NotDefined'
                                        let actionTarget: string = null
                                        if (names.parentElementName && action[names.parentElementName]) {
                                            parentElementName = null
                                            actionTarget = action[names.parentElementName]
                                        } else {
                                            parentElementName = (this.moduleDataType == DataType.HELPER_ID_LOCATION) ? 'Location'
                                                : (this.moduleDataType == DataType.HELPER_SERIAL_NBR ? 'Device'
                                                    : (this.moduleDataType == DataType.HELPER_ID_METER ? 'Meter' : 'NotDefined'))
                                        }
                                        this.tileActions.push({
                                            type: action.actionType.toString(),
                                            status: action.actionStatus.toString(),
                                            parentElementId: this.selectedRowsNames[index],
                                            parentElementName,
                                            actionTarget,
                                            succeded,
                                            failed
                                        })
                                    })
                                    createNewActionsList()
                                    this.statusPopup.repaint()
                                    $scope.checkStatus = checkStatus
                                    $scope.secondsCounter = ActionStatusController.WAIT_SECOND
                                    if (!this.breakCode) {
                                        countDown(result)
                                    }
                                } else {
                                    $scope.isStatusPopupVisible = false
                                    CommonHelper.openInfoPopup(i18n('Popup', 'GetActionProblem'), 'error', 5000)
                                }
                            })
                    })
                    .always(() => {
                        $scope.showTileView = true
                    })
            })
        }

        $scope.$on(EventsNames.SHOW_ACTION_STATUS_POPUP + $scope.popupId, (event: ng.IAngularEvent, ...args: any[]) => {
            this.breakCode = false
            let actionStatusOptions: ActionStatusOptions = args[0]
            this.selectedRowsNames = actionStatusOptions.selectedRowsNames
            this.actionStatusOptions = actionStatusOptions

            executeGetActions(actionStatusOptions.actionResult, true)
            if (actionStatusOptions.moduleDataType)
                this.moduleDataType = actionStatusOptions.moduleDataType
        })
    }

    private toggleAllOnCheckBox(): void {
        const allChecked: boolean = this.showInProgress && this.showFailed && this.showSucceded

        if (!allChecked) {
            this.skipDisableAll = true
        }

        this.$scope.checkBoxAllOn = allChecked
    }
}